import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import GalleryUploader from "@/components/GalleryUploader";

/**
 * GalleryDialog — gestisce la galleria foto del prodotto madre.
 *
 * - La prima foto è la COVER (cover_url = product.immagini[0])
 * - Caricamento multiplo, riordino, eliminazione, "imposta come cover"
 *
 * Props:
 *   - product: { id, sku_madre, nome, immagini: string[] }
 *   - onClose(saved: bool)
 */
export default function GalleryDialog({ product, onClose }) {
  const [images, setImages] = useState(Array.isArray(product?.immagini) ? product.immagini : []);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/products/${product.id}`, { immagini: images });
      toast.success(images.length === 0
        ? "Galleria svuotata"
        : `Galleria salvata (${images.length} foto, cover = foto 1)`);
      onClose && onClose(true);
    } catch (e) {
      toast.error("Errore salvataggio: " + (e.response?.data?.detail || e.message));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={() => onClose && onClose(false)}>
      <DialogContent className="max-w-3xl max-h-[92vh] overflow-auto" data-testid="gallery-dialog">
        <DialogHeader>
          <DialogTitle>
            Galleria foto — <span className="font-mono text-xs">{product?.sku_madre}</span> {product?.nome}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <GalleryUploader value={images} onChange={setImages} testid="prod-gallery" max={16} />

          <div className="flex gap-2 sticky bottom-0 bg-white border-t border-border pt-3 -mx-6 px-6 -mb-6 pb-5">
            <button onClick={() => onClose && onClose(false)} className="flex-1 h-10 border border-border rounded-sm text-sm" data-testid="gallery-cancel">
              Annulla
            </button>
            <button onClick={save} disabled={saving}
              className="flex-1 h-10 bg-brand text-white rounded-sm text-sm font-medium hover:bg-brand-hover disabled:opacity-50 inline-flex items-center justify-center gap-1.5"
              data-testid="gallery-save">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
              Salva galleria
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
